import React from "react"
import LinkElement from "../elements/link_element"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbRte from "../ui-kit/dfb_rte"
import DfbAnchor from "../ui-kit/dfb_anchor"
import DfbIcon from "../ui-kit/dfb_icon"
import Section from "./section"

const MScienceCategoriesOverview = (props) => {
  const isBoldLayout = props.data.layout === 1

  const tiles = () => {
    return props.data.tile.map((item) => (
      <li
        key={item.title}
        className={`m-ScieneCategoriesOverview-tile ${
          !isBoldLayout ? "dfb-Slider-slideItem" : ""
        }`}
      >
        <LinkElement
          link={item.link}
          add_class={`c-CategoryCard ${
            item.infobox ? "c-CategoryCard--filledGreen" : ""
          } ${isBoldLayout ? "c-CategoryCard--bold" : ""}`}
        >
          {item.title && (
            <DfbHeadline
              headline={item.title}
              headline_level="h6"
              add_class="c-CategoryCard-headline"
            />
          )}
          {item.link && !!item.infobox && <DfbIcon icon_type="Arrow Right" />}
          {item.icon && !item.infobox && (
            <DfbIcon icon_type={item.icon} add_class="c-CategoryCard-icon" />
          )}
          {item.link_text && !item.infobox && (
            <DfbAnchor
              tagName="div"
              secondary={true}
              add_class="dfb-Card-anchor"
              text={item.link_text}
            />
          )}
        </LinkElement>
      </li>
    ))
  }

  return (
    <Section
      baseClass={`m-ScieneCategoriesOverview ${
        isBoldLayout ? "m-ScieneCategoriesOverview--bold" : ""
      } ${props.data.background_color !== "grey" ? "u-Theme-dark" : ""}`}
      data={props.data}
    >
      <div className="m-ScieneCategoriesOverview-wrapper">
        <div className="m-ScieneCategoriesOverview-container">
          {props.data.headline && (
            <DfbHeadline
              headline={props.data.headline}
              headline_level="h2"
              add_class="m-ScieneCategoriesOverview-headline"
            />
          )}
          {props.data.text && (
            <DfbRte
              text={`<p>${props.data.text}</p>`}
              add_class="m-ScieneCategoriesOverview-text"
            />
          )}
          {isBoldLayout ? (
            <ul
              className="m-ScieneCategoriesOverview-list"
              data-length={props.data.tile.length}
            >
              {tiles()}
            </ul>
          ) : (
            <div
              className="dfb-Slider m-ScieneCategoriesOverview-slider"
              data-transition="slide"
              data-indicators
              data-drag
              role="region"
              tabIndex={0}
            >
              <div className="dfb-Slider-slider">
                <ul className="dfb-Slider-slides">{tiles()}</ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </Section>
  )
}

export default MScienceCategoriesOverview
